import { createSlice } from '@reduxjs/toolkit';

import { createProjectTour } from './actions/create-project-tour.action';
import { editProjectTour } from './actions/edit-project-tour.action';
import { getProjectTour } from './actions/get-project-tour.action';
import { getProjectsTour } from './actions/get-projects-tour.action';
import { ProjectTour } from './entities/project-tour.entity';

export type ProjectTourState = {
  items: ProjectTour[];
  current: ProjectTour | null;
  isFetchingProjects: boolean;
  isFetchingCurrentProject: boolean;
  isCreatingProject: boolean;
  isEditingProject: boolean;
};

const initialState: ProjectTourState = {
  items: [],
  current: null,
  isFetchingProjects: false,
  isFetchingCurrentProject: false,
  isCreatingProject: false,
  isEditingProject: false,
};

export const projectTourSlice = createSlice({
  name: 'projectTour',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      // getProjectsTour
      .addCase(getProjectsTour.pending, (state) => {
        state.isFetchingProjects = true;
      })
      .addCase(getProjectsTour.fulfilled, (state, action) => {
        state.isFetchingProjects = false;
        state.items = action.payload;
      })
      .addCase(getProjectsTour.rejected, (state) => {
        state.isFetchingProjects = false;
      })
      // getProjectTour
      .addCase(getProjectTour.pending, (state) => {
        state.isFetchingCurrentProject = true;
      })
      .addCase(getProjectTour.fulfilled, (state, action) => {
        state.isFetchingCurrentProject = false;
        state.current = action.payload;
      })
      .addCase(getProjectTour.rejected, (state) => {
        state.isFetchingCurrentProject = false;
      })
      // createProjectTour
      .addCase(createProjectTour.pending, (state) => {
        state.isCreatingProject = true;
      })
      .addCase(createProjectTour.fulfilled, (state) => {
        state.isCreatingProject = false;
      })
      .addCase(createProjectTour.rejected, (state) => {
        state.isCreatingProject = false;
      })
      // editProjectTour
      .addCase(editProjectTour.pending, (state) => {
        state.isEditingProject = true;
      })
      .addCase(editProjectTour.fulfilled, (state) => {
        state.isEditingProject = false;
      })
      .addCase(editProjectTour.rejected, (state) => {
        state.isEditingProject = false;
      });
  },
});
